import React from "react";
import CardHover from "./CardHover";
import { ShowMore, ShowMoreColumn } from "./StyledComponents/ShowMore.style";
import "./StyledComponents/style.css";
import { isMobile } from "react-device-detect";

import IconPhone from "./asset/pictures/undraw_mobile_development_8gyo.svg";
import IconMail from "./asset/pictures/undraw_Mail_sent_re_0ofv.svg";
import IconCV from "./asset/pictures/undraw_updated_resume_u4fy 1.svg";

import CardForMobile from "./CardForMobile";

const MoreContact = () => {
  return (
    <>
      {isMobile ? (
        <ShowMore>
          <CardForMobile
            icon={IconMail}
            link="mailto:monia.laoufi@gmail.com?subject=Je vous veux Monia !"
          />
          <CardForMobile icon={IconPhone} link="tel:+33659559839" />
          <CardForMobile
            icon={IconCV}
            link="https://www.canva.com/design/DADcvoyKQsk/dZd7tNcKTUWfpVyOV7EOaw/view?utm_content=DADcvoyKQsk&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink"
          />
        </ShowMore>
      ) : (
        <ShowMoreColumn>
          <CardHover
            title="Mail"
            content="monia.laoufi@gmail.com"
            icon={IconMail}
            link="mailto:monia.laoufi@gmail.com"
          />
          <CardHover
            title="Tel"
            content="06.59.55.98.39"
            icon={IconPhone}
            link="tel:+33659559839"
          />
          <CardHover
            title="CV"
            content="Lien vers mon CV"
            icon={IconCV}
            link="https://www.canva.com/design/DADcvoyKQsk/dZd7tNcKTUWfpVyOV7EOaw/view?utm_content=DADcvoyKQsk&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink"
          />
        </ShowMoreColumn>
      )}
    </>
  );
};

export default MoreContact;
